<template>
  <div ref="wang" :style="{ width }"></div>
</template>

<script>
import wangEditor from 'wangeditor';
import { uploadImage } from '@/api/upload';
import { isSuccess, getCompletionUrl } from '@/utils/index';
export default {
  props: {
    // wangEditor 的配置
    option: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    useImage: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  watch: {
    // 监听父组件传值，将值赋值给编辑器
    value(n) {
      if (this.editor && n !== this.temp) {
        this.editor.$textElem.html(n);
      }
    },
    disabled(newVal) {
      newVal ? this.editor.disable() : this.editor.enable();
    },
  },
  data() {
    return {
      temp: '', // 缓存当前的编辑器中的值，用于与父组件传入值进行对比
      editor: null,
    };
  },
  mounted() {
    this.editor = new wangEditor(this.$refs.wang);

    // 合并配置项
    Object.assign(this.editor.config, this.option);

    // v-model 双向绑定：把值发送到父组件（不占用用户的 onchange 配置）
    this.editor.txt.eventHooks.changeEvents.push(() => {
      this.temp = this.editor.$textElem.html();
      this.$emit('input', this.temp);
    });

    this.editor.config.placeholder = '';

    // 取消自动 focus
    this.editor.config.focus = false;
    // 设置z-index
    this.editor.config.zIndex = 1000;
    this.editor.config.pasteIgnoreImg = true;
    this.editor.config.customUploadImg = async function (
      resultFiles,
      insertImgFn
    ) {
      let formData = new FormData();
      formData.append('file', resultFiles[0]);
      const res = await uploadImage(formData);
      if (isSuccess(res.code)) {
        insertImgFn(getCompletionUrl(res.data.file));
      }
    };

    this.editor.create();

    if (this.value.length) {
      this.editor.txt.html(this.value);
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>
